import { ChainId } from '@aave/contract-helpers';
import { Box } from '@mui/material';
import React, { ReactNode } from 'react';
// import { useModalContext } from 'src/hooks/useModal';
import { SupportModal } from 'src/layouts/SupportModal';

import { AppFooter } from './AppFooter';
import { AppHeader } from './AppHeader';
import TopBarNotify from './TopBarNotify';

const getCampaignConfigs = () => ({
  [ChainId.base]: {
    notifyText: 'Dinolend V3 test markets are available for engineering review.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: '/markets',
      target: '_blank' as const,
    },
    bannerVersion: 'dinolend-v3-review-v0',
  },

  [ChainId.sonic]: {
    notifyText: 'Dinolend V3 test markets are available for engineering review.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: '/markets',
      target: '_blank' as const,
    },
    bannerVersion: 'dinolend-v3-review-v0',
    // icon: '/icons/networks/sonic.svg',
  },

  [ChainId.mainnet]: {
    notifyText: 'Dinolend V3 test markets are available for engineering review.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: '/markets',
      target: '_blank' as const,
    },
    bannerVersion: 'dinolend-v3-review-v0',
  },

  [ChainId.polygon]: {
    notifyText: 'Dinolend V3 test markets are available for engineering review.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: '/markets',
      target: '_blank' as const,
    },
    bannerVersion: 'dinolend-v3-review-v0',
    // icon: '/icons/networks/polygon.svg',
  },

  [ChainId.avalanche]: {
    notifyText: 'Dinolend V3 test markets are available for engineering review.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: '/markets',
      target: '_blank' as const,
    },
    bannerVersion: 'dinolend-v3-review-v0',
    // icon: '/icons/networks/avalanche.svg',
  },

  [ChainId.arbitrum_one]: {
    notifyText: 'Dinolend V3 test markets are available for engineering review.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: '/markets',
      target: '_blank' as const,
    },
    bannerVersion: 'dinolend-v3-review-v0',
    // icon: '/icons/networks/arbitrum.svg',
  },

  [ChainId.optimism]: {
    notifyText: 'Dinolend V3 test markets are available for engineering review.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: '/markets',
      target: '_blank' as const,
    },
    bannerVersion: 'dinolend-v3-review-v0',
    // icon: '/icons/networks/optimism.svg',
  },

  [ChainId.xdai]: {
    notifyText: 'Dinolend V3 test markets are available for engineering review.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: '/markets',
      target: '_blank' as const,
    },
    bannerVersion: 'dinolend-v3-review-v0',
    // icon: '/icons/networks/gnosis.svg',
  },

  [ChainId.bnb]: {
    notifyText: 'Dinolend V3 test markets are available for engineering review.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: '/markets',
      target: '_blank' as const,
    },
    bannerVersion: 'dinolend-v3-review-v0',
    // icon: '/icons/networks/binance.svg',
  },

  [ChainId.ink]: {
    notifyText: 'Tydro is temporarily pausing all reserves.',
    buttonText: 'Learn more',
    buttonAction: {
      type: 'url' as const,
      value: 'https://x.com/tydrohq/status/2051383181874540957?s=20',
      target: '_blank' as const,
    },
    bannerVersion: 'dinolend-ink-paused-v0',
  },
});

// For defining Route specific campaigns if needed in future
const routeCampaigns = {
  // '/sgho': {
  //   notifyText: "Earn 4% higher yield on savings GHO using OKX's GHO staking vault.",
  //   buttonText: 'Learn more',
  //   buttonAction: {
  //     type: 'url' as const,
  //     value: '/markets',
  //     target: '_blank' as const,
  //   },
  //   bannerVersion: 'sgho-okx-v1',
  // },
};

export function MainLayout({ children }: { children: ReactNode }) {
  const campaignConfigs = getCampaignConfigs();

  return (
    <>
      <TopBarNotify campaigns={campaignConfigs} routeCampaigns={routeCampaigns} />

      <AppHeader />
      <Box component="main" sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        {children}
      </Box>
      <AppFooter />
      <SupportModal />
    </>
  );
}
